//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,1],[["option"],"GetPartBuilderForClone",{R_:{part_builder:"PDM.PartFromPartBuilder"}},1,1],[["value"],"SetIncludeMaster",{},1,1],[["option"],"GetContainer",{R_:{container:''}},1,1],[["option","container"],"SetContainer",{},2,1],[[],"CommitClone",{},0,1]],[]];
SPLM.PDM.CaeCloneManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.CaeCloneManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.CaeCloneManager.CloneOption = Object.freeze({
    "None" : "None", "Sim" : "Sim", "Fem" : "Fem", "Ideal" : "Ideal", "Master" : "Master"});

export default SPLM;